import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FraisscolariteProfileLayout from './FraisscolariteProfileLayout';

// import utility file
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import FraisscolariteService from '../../services/FraisscolariteService';
import AnneescolaireService from '../../services/AnneescolaireService';

const ViewFraisscolarite = () => {
	const { id } = useParams();
	const [fraisscolarite, setFraisscolarite] = useState(null);
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [selectedGroupe, setSelectedGroupe] = useState([]);
	const [selectedTranche, setSelectedTranche] = useState([]);
	const [currentSchoolYear, setCurrentSchoolYear] = useState(null);

	useEffect(() => {
		const fetchCurrentSchoolYear = async () => {
			try {
				const schoolYear = await AnneescolaireService.getCurrentAnneescolaire();
				setCurrentSchoolYear(schoolYear.data);
			} catch (error) {
				console.error(
					"Erreur lors de la récupération de l'année scolaire en cours:",
					error
				);
				alert(
					`Erreur lors de la récupération de l'année scolaire en cours. Détails de l'erreur : ${error.message}`
				);
			}
		};

		fetchCurrentSchoolYear();
	}, []);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const fraisscolariteData =
					await FraisscolariteService.getFraisscolarite(id);

				setFraisscolarite(fraisscolariteData.data);

				if (fraisscolariteData && fraisscolariteData.data) {
					setSelectedGroupe(fraisscolariteData.data.groupe);
					setSelectedTranche(fraisscolariteData.data.tranche);
				} else if (fraisscolariteData) {
					setSelectedGroupe(fraisscolariteData.groupe);
					setSelectedTranche(fraisscolariteData.tranche);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};

		fetchData();
	}, [id]);

	const TRANCHE_CHOICES = [
		{ value: 'inscription', label: 'Inscription' },
		{ value: 'tranche_1', label: '1ere Tranche' },
		{ value: 'tranche_2', label: '2eme Tranche' },
		{ value: 'tranche_3', label: '3eme Tranche' }
	];

	const GROUPE_CHOICES = [
		{ value: 'pre_mat', label: 'Pré-Maternelle' },
		{ value: 'mat', label: 'Maternelle' },
		{ value: 'pri', label: 'Primaire' },
		{ value: 'class6_cm2', label: 'Class 6 et CM2' }
	];

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const fraisscolariteData = new FormData();

				// Add all your form data to the FormData
				fraisscolariteData.append('tranche', form.tranche.value);
				fraisscolariteData.append('montant', form.montant.value);
				fraisscolariteData.append('groupe', form.groupe.value);
				fraisscolariteData.append('date_limite', form.date_limite.value);
				fraisscolariteData.append('anneescolaire', currentSchoolYear.id);

				// Call the TrancheService to create the tranche
				const response = await FraisscolariteService.updateFraisscolarite(
					id,
					fraisscolariteData
				);

				// Reset the form and state variables after successful update
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Add this line to refresh the page
				window.location.reload();
			} catch (error) {
				console.error(
					'Erreur lors de la mise à jour des informations sur les frais de scolarité',
					error
				);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<FraisscolariteProfileLayout>
			{fraisscolarite && (
				<>
					<Card className="mb-3 ">
						{/* Card body */}
						<Card.Body>
							{/*  Form  */}
							<Form
								className="mb-3"
								noValidate
								validated={validated}
								onSubmit={handleSubmit}
							>
								{showAlert && (
									<Alert variant="danger">
										<ExclamationTriangleFill size={25} className="me-1" />
										{alertMessage}
									</Alert>
								)}
								<Row>
									<Col xs={12} className="mb-3">
										<Form.Group className="mb-3">
											<Form.Label htmlFor="groupe">Groupe</Form.Label>
											<Form.Select
												name="groupe"
												required
												value={selectedGroupe}
												isInvalid={!!feedbackMessages['groupe']}
												onChange={(e) => {
													const value = e.target.value;
													setSelectedGroupe(value);
												}}
											>
												<option value="">
													Selectionner la groupe concerné
												</option>
												{GROUPE_CHOICES.map((choice, index) => (
													<option key={index} value={choice.value}>
														{choice.label}
													</option>
												))}
											</Form.Select>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['groupe']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									<Col xs={12} className="mb-3">
										{/* tranche et montant */}
										<Form.Group>
											<Row>
												<Col md={6} sm={12} className="mb-3">
													<Form.Group className="mb-3">
														<Form.Label htmlFor="tranche">
															Tranche <span className="text-danger">*</span>
														</Form.Label>
														<Form.Select
															name="tranche"
															options={TRANCHE_CHOICES}
															required
															value={selectedTranche}
															isInvalid={!!feedbackMessages['tranche']}
															onChange={(e) => {
																const value = e.target.value;
																setSelectedTranche(value);
															}}
														>
															<option value="">
																Selectionner la tranche concernée
															</option>
															{TRANCHE_CHOICES.map((choice, index) => (
																<option key={index} value={choice.value}>
																	{choice.label}
																</option>
															))}
														</Form.Select>
														<Form.Control.Feedback type="invalid">
															{feedbackMessages['tranche']}
														</Form.Control.Feedback>
													</Form.Group>
												</Col>

												<Col md={6} sm={12} className="mb-3">
													<Form.Label htmlFor="montant">
														Montant <span className="text-danger">*</span>
													</Form.Label>
													<Form.Control
														name="montant"
														type="number"
														placeholder="Saisir les montant "
														id="montant"
														defaultValue={fraisscolarite.montant}
														required
														isInvalid={!!feedbackMessages['montant']}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																montant: e.target.value
																	? ''
																	: 'Le montant est requis.'
															}));
														}}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['montant']}
													</Form.Control.Feedback>
												</Col>
											</Row>
										</Form.Group>
									</Col>

									<Col xs={12} className="mb-3">
										{/* date_limite */}
										<Form.Group>
											<Form.Label htmlFor="date_limite">
												Date limite <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="date_limite"
												type="date"
												placeholder="Saisir la date limite de paiment "
												id="date_limite"
												defaultValue={fraisscolarite.date_limite}
												required
												isInvalid={!!feedbackMessages['date_limite']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														date_limite: e.target.value
															? ''
															: 'La date limite est requis.'
													}));
												}}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['date_limite']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Buttons */}
									<Col xs={12} className="mt-4">
										<Button variant="success" type="submit">
											Mettre à jour
										</Button>
										<Button
											type="reset"
											variant="outline-danger"
											className="ms-2"
										>
											Effacer
										</Button>
									</Col>
								</Row>
							</Form>
						</Card.Body>
					</Card>
				</>
			)}
		</FraisscolariteProfileLayout>
	);
};

export default ViewFraisscolarite;
